import { Link } from '@avensia/excite';
import { styled } from '@glitz/react';
import * as React from 'react';
import {
  addSelectRetailMediaBannerToDataLayer,
  addViewRetailMediaBannerToDataLayer,
  useRetailMediaViewEventTrigger,
} from 'webapp/tracking/events/retail-media';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { Image } from '@avensia/excite-ui';

export enum AdSize {
  Large,
  Medium,
}

function adSizeDecorator(size: AdSize) {
  switch (size) {
    case AdSize.Large:
      return styled(
        createMinLargeViewportDecorator({
          gridColumnStart: 'span 4',
        }),
        {
          gridColumnStart: 'span 2',
        },
        contentDecorator,
      );
    case AdSize.Medium:
      return styled(
        {
          gridColumnStart: 'span 2',
        },
        contentDecorator,
      );
  }
}

const AdBlockContext = React.createContext<AdSize | undefined>(undefined);

type PropType = { size: AdSize; isSmallViewport?: boolean; banner?: NordicNest.Api.RetailMediaBanner };

export default function InlineRetailMediaBannerAd({ size, banner }: PropType) {
  const self = React.useRef<HTMLLIElement | null>(null);
  useRetailMediaViewEventTrigger(self, addViewRetailMediaBannerToDataLayer, { adId: banner?.adId });

  if (!banner) {
    return null;
  }

  const content = (
    <>
      <BannerImage url={banner.imageUrl} alt={banner?.altText} />
    </>
  );

  return (
    <AdBlockContext.Provider value={size}>
      <ListItem css={adSizeDecorator(size)} ref={self}>
        <Base
          to={banner.linkUrl}
          onClick={() => {
            addSelectRetailMediaBannerToDataLayer(banner?.adId);
          }}
        >
          {content}
        </Base>
      </ListItem>
    </AdBlockContext.Provider>
  );
}

const contentDecorator = styled({
  textAlign: 'center',
  fontFamily: t => t.fontFamily?.secondary,
});

const Base = styled(Link, {
  position: 'relative',
  width: '100%',
  display: 'block',
});

const ListItem = styled.li({
  width: '100%',
});

const BannerImage = styled(Image, {
  width: '100%',
  height: 'auto',
  display: 'block',
});
